module.exports = "/static/assets/7ab00ab8daefd87e10f305514cb6a253.png";